import { MarknadsprislistaTyp } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../common/validation/ValidationScopes";
import { ValidationContext } from "../../../../common/validation/validationContext";
import { IMarknadsprislista } from "../../models/marknadsprislista-model";

export class MarknadsprislistaValidation {
    static init(prislista: IMarknadsprislista): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "ViolID får ej vara tomt" },
                model: () => prislista.violId,
                expression: newVal => ObjectUtils.stringHasValue(newVal),
                name: "violId",
                publish: true
            },
            {
                applicable: () => prislista.typ === MarknadsprislistaTyp.Viol2,
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                expression: newVal => newVal?.length === 6,
                message: { text: "ViolID måste bestå av 6 tecken" },
                model: () => prislista.violId,
                name: "violId",
                publish: true
            },
            {
                applicable: () => prislista.typ === MarknadsprislistaTyp.Viol3 && ObjectUtils.stringHasValue(prislista.violId),
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                expression: newVal => newVal?.length <= 10,
                message: { text: "ViolID för viol3 måste bestå av högst 10 tecken" },
                model: () => prislista.violId,
                name: "violId",
                publish: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: "Prislista måste ha ett startdatum" },
                model: () => prislista.gallerFrom,
                name: "gallerFrom",
                publish: true,
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                expression: (x) => x !== undefined && x.length > 0,
                message: { text: "Prislistan måste ha minst en region" },
                model: () =>  prislista.resultatomraden,
                name: "resultatomraden",
                publish: true,
                required: true
            }
        ]);
        return context;
    }
}
